import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Checkbox,
	CircularProgress,
	Dialog,
	Icon,
	IconButton,
	InputAdornment,
	MenuItem,
	Switch,
	TextField,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined, Close } from '@material-ui/icons'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { KeyboardDatePicker } from '@material-ui/pickers'
import DatePicker from 'react-multi-date-picker'
import moment from 'moment'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { v4 as uuid } from 'uuid'
import { showError, showSuccess } from '../../actions/misc/misc.actions'
import { api } from '../../services/api'
import {
	ACCESS_TYPES,
	ADDON_REVENUE_TYPES,
	NON_BREAKING_SPACE,
	sortByKey,
	onlyNumbers,
	formatNumsToDollars,
	DAYCARE,
	PETCARE
} from '../../utils'
import StyledSelect from '../Common/StyledSelect'

const grooming_types = [
	'Nail Filing',
	'Fresh Breath',
	'Health Skin & Coat',
	'Shed Control',
	'Flea & Tick Care',
	'De-Matting'
]

const days_of_week = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

const default_days = {
	Monday: '',
	Tuesday: '',
	Wednesday: '',
	Thursday: '',
	Friday: '',
	Saturday: '',
	Sunday: ''
}

const useStyles = makeStyles((theme) => ({
	daysOfWeek: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		marginBottom: 16
	},
	errorBtn: {
		display: 'flex',
		minWidth: 48,
		width: 48,
		height: 48,
		padding: 0,
		justifyContent: 'center',
		alignItems: 'center',
		border: '1px solid red',
		borderRadius: 24
	},
	dialog: {
		'& .MuiCardHeader-root': {
			padding: 2,
			paddingLeft: 8
		},
		'& .MuiDialog-paper': {
			width: '1200px',
			padding: 0
		},
		'& .MuiDialog-paperWidthSm': {
			maxWidth: 1200
		}
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '15px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		marginBottom: 16,
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		}
	},
	switchBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		height: 50,
		width: '32%',
		paddingLeft: 16,
		paddingRight: 16,
		marginBottom: 12,
		marginTop: 12
	},
	switchRoot: {
		width: 51,
		height: 31,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
			backgroundColor: '#6B4AD6',
			opacity: 1
		},
		'&$checked': {
			transform: 'translateX(20px)',
			color: theme.palette.common.white,
			'& + $track': {
				backgroundColor: '#6B4AD6',
				opacity: 1
			},
			'& .far::before': {
				color: '#6B4AD6',
				opacity: 1
			},
			'& .far': {
				color: '#6B4AD6'
			}
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6'
			//border: "6px solid #fff",
		}
	},
	thumb: {
		width: 27,
		height: 27,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px',
			lineHeight: '15px'
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	checkRow: {
		width: '25%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
		// padding: 12,
	},
	datePicker: {
		marginBottom: 16,
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		}
	}
}))

const NewAddOnDialog = ({ isShown, ...props }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const waiverInputRef = useRef(null)
	const [isStartDateOpen, setIsStartDateOpen] = useState(false)
	const [imageLoading, setImageLoading] = useState(false)
	const [loading, setLoading] = useState(false)
	const [isEndDateOpen, setIsEndDateOpen] = useState(false)
	const [addOn, setAddOn] = useState({
		name: '',
		_id: '',
		price: 0,
		min_price: 0,
		max_price: 0,
		temp_file: null,
		available_boarding: true,
		available_daycare: true,
		daycare_default_time: 'midday',
		boarding_default_time: 'midday',
		active: false,
		access: 'Inactive',
		do_not_show_if_unavailable: false,
		revenue_type: PETCARE,
		standalone_service: false,
		vip_only: false,
		comfort_plus_included: false,
		signature_play_included: false
	})
	// const [startDate, updateStartDate] = useState(null)
	// const [endDate, updateEndDate] = useState(null)

	const isAStandaloneService = addOn?.standalone_service === true

	useEffect(() => {
		if (props.addOn && props.addOn._id && props.addOn._id !== addOn._id) {
			setAddOn({ ...props.addOn, revenue_type: props.addOn.revenue_type || PETCARE })
			if (props.addOn.icon) setIconApplied(true)
		}
	}, [props])

	useEffect(() => {
		if (!isShown && addOn._id && !props.addOn._id) {
			setAddOn({
				name: '',
				_id: '',
				price: 0,
				min_price: 0,
				max_price: 0,
				daycare_default_time: 'midday',
				boarding_default_time: 'midday',
				temp_file: null
			})
		}
	}, [isShown])

	const [iconApplied, setIconApplied] = useState(false)
	const { setIsShown, facility } = props
	const addOnCategories = (facility?.addons_categories || []).sort(sortByKey((a) => a.order))

	const daycareTimes = addOn.daycare_time_blocks || []
	const boardingTimes = addOn.boarding_time_blocks || []

	const isNotReady = () => {
		if (
			!addOn.name ||
			!addOn.category ||
			!addOn.type ||
			!addOn.icon ||
			!addOn.description ||
			(addOn.available_daycare && !addOn.daycare_default_time) ||
			(addOn.available_boarding && !addOn.boarding_default_time)
		) {
			return true
		}

		if (addOn.variable_price && (!addOn.min_price || !addOn.max_price)) return true
		if (addOn.limited && (!addOn.startDate || !addOn.endDate)) return true
		if (!addOn.variable_price && !addOn.price && addOn.price !== 0) return true
		return false
	}

	const shouldCloneRatherThanUpdate = useMemo(() => {
		// For now no training service is cloned as it requires
		// updating the related training courses as well on the api side.
		if (addOn.training_service) {
			return false
		}
		return props.addOn.price !== onlyNumbers(addOn.price)
	}, [props, addOn.price, addOn.training_service])

	const saveAddOn = async () => {
		try {
			// console.info('saveAddOn', { addOn })
			setLoading(true)

			let is_grooming_service = false
			let category = addOnCategories.find((c) => c._id === addOn.type)
			if (category.grooming_service) is_grooming_service = true
			let image_url
			if (addOn.temp_file) {
				const { url } = await uploadFileForNewAddOn()
				image_url = url
			}

			let grooming_addon_type
			if (is_grooming_service) {
				grooming_addon_type = grooming_types.find((g) => g === addOn.name)
				if (!grooming_addon_type) {
					// throw new Error(
					// 	`Addon name must match one of the available grooming addon types: ${
					// 		('Nail Filing',
					// 		'Fresh Breath',
					// 		'Health Skin & Coat',
					// 		'Shed Control',
					// 		'Flea & Tick Care',
					// 		'De-Matting')
					// 	}`
					// )
					console.info(
						`Addon name must match one of the available grooming addon types: ${
							('Nail Filing',
							'Fresh Breath',
							'Health Skin & Coat',
							'Shed Control',
							'Flea & Tick Care',
							'De-Matting')
						}`
					)
				}
			}

			let bod = {
				...addOn,
				facility_id: facility._id,
				grooming_service: is_grooming_service,
				grooming_addon_type,
				price: onlyNumbers(addOn.price),
				min_price: onlyNumbers(addOn.min_price),
				max_price: onlyNumbers(addOn.max_price),
				available_boarding: addOn.available_boarding ? true : false,
				available_daycare: addOn.available_daycare ? true : false,
				vip_only: !!addOn.vip_only,
				comfort_plus_included: !!addOn.comfort_plus_included,
				signature_play_included: !!addOn.signature_play_included,
				addon_choices: addOn.addon_choices
					? addOn.addon_choices.map((c) => {
							return {
								...c,
								upcharge: onlyNumbers(c.upcharge)
							}
					  })
					: [],
				active: addOn.access === 'Inactive' ? false : true,
				should_clone: shouldCloneRatherThanUpdate
			}
			// let's delete unused fields on backend
			if (bod.access === 'Inactive') delete bod.access

			if (image_url) bod.image_url = image_url
			if (!bod.price && bod.min_price) bod.price = bod.min_price
			if (addOn.category === 'pet') {
				addOn.boarding_time_blocks = addOn.boarding_default_time
					? [addOn.boarding_default_time]
					: ['midday']
				addOn.daycare_time_blocks = addOn.daycare_default_time ? [addOn.daycare_default_time] : ['midday']
			}

			let { data } = await api.put(`/createAddOnType`, bod)

			if (addOn._id) {
				if (shouldCloneRatherThanUpdate) {
					dispatch({ type: 'CREATE_ADDON_TYPE', payload: data })
					dispatch({
						type: 'UPDATE_ADDON_TYPE',
						payload: {
							...props.addOn,
							active: false,
							isCurrentlyFeatured: data?.isCurrentlyFeatured || false,
							newId: data._id
						}
					})
				} else {
					dispatch({ type: 'UPDATE_ADDON_TYPE', payload: data })
				}
			} else {
				dispatch({ type: 'CREATE_ADDON_TYPE', payload: data })
			}

			setTimeout(() => {
				setLoading(false)

				dispatch(showSuccess(addOn._id ? 'Enrichment Updated' : 'Enrichment Created'))
				setIsShown(false)
				setAddOn({
					name: '',
					price: 0,
					min_price: 0,
					max_price: 0,
					temp_file: null,
					available_boarding: true,
					available_daycare: true,
					daycare_default_time: 'midday',
					boarding_default_time: 'midday'
				})
				setIconApplied(false)
			}, 600)
		} catch (e) {
			console.log('error...', e.toString())
			setLoading(false)
			dispatch(showError(addOn._id ? `Error updating addon: ${e.toString()}` : 'Error creating addon'))
		}
	}

	const getIconName = (add) => {
		let icon
		if (add.type === 'bath') {
			icon = 'bath'
		} else if (add.type === 'treat') {
			icon = 'bone'
		} else if (add.icon) {
			icon = add.icon
		}
		return icon
	}

	const getAccess = (add) => {
		if (!add.active) return 'Inactive'
		if (!add.access || add.access === ACCESS_TYPES.GlobalAccess) return ACCESS_TYPES.GlobalAccess
		return ACCESS_TYPES.AdminOnly
	}

	const setTime = (type, time) => {
		if (type === DAYCARE) {
			let times = addOn.daycare_time_blocks || []
			let newTimes
			if (times.includes(time)) {
				newTimes = times.filter((t) => t !== time)
			} else {
				newTimes = [...times, time]
			}
			setAddOn({
				...addOn,
				daycare_time_blocks: newTimes
			})
		} else {
			let times = addOn.boarding_time_blocks || []
			let newTimes
			if (times.includes(time)) {
				newTimes = times.filter((t) => t !== time)
			} else {
				newTimes = [...times, time]
			}
			setAddOn({
				...addOn,
				boarding_time_blocks: newTimes
			})
		}
	}

	const getDates = (start, end) => {
		let dates = []
		for (let i = moment(start); i.isBefore(moment(end).endOf('day')); i.add(1, 'day')) {
			dates.push(i.format('YYYY-MM-DD'))
		}
		return dates
	}

	const uploadFile = async (e) => {
		try {
			if (addOn._id) {
				setImageLoading(true)
				if (e.target.files && e.target.files.length && e.target.files[0]) {
					let file
					file = e.target.files[0]

					const data = new FormData()
					data.append('addon_image', file)

					const addonData = await api.put(`/addOnImages/${addOn._id}`, data)
					setAddOn({
						...addOn,
						image_url: addonData.data.image_url
					})
				}
				dispatch(showSuccess('Image uploaded. Save addon to apply changes.'))
				setImageLoading(false)
			} else {
				if (e.target.files && e.target.files.length && e.target.files[0]) {
					let file
					file = e.target.files[0]

					setAddOn({
						...addOn,
						temp_file: e.target.files[0]
					})
				}
			}
		} catch (e) {
			console.log('err...', e)
			dispatch(showError('Error uploading image.'))
			setImageLoading(false)
		}
	}

	const uploadFileForNewAddOn = async (id) => {
		return new Promise(async (resolve, rej) => {
			try {
				const data = new FormData()
				data.append('addon_image', addOn.temp_file)
				const addonData = await api.put(`/addOnImages/newOne`, data)

				resolve({ url: addonData.data.image_url })
			} catch (e) {
				console.log('err...', e)
				dispatch(showError('Error uploading image.'))
				rej()
			}
		})
	}

	const updateChoice = (id, key, value) => {
		const choices = [...addOn.addon_choices]
		const ourChoice = choices.find((c) => c.id === id)
		ourChoice[key] = value
		setAddOn({
			...addOn,
			addon_choices: choices
		})
	}

	const removeChoice = (id) => {
		const choices = addOn.addon_choices.filter((c) => c.id !== id)
		setAddOn({
			...addOn,
			addon_choices: choices
		})
	}

	const addChoice = () => {
		const choices = [...addOn.addon_choices]
		choices.push({
			name: '',
			upcharge: 0,
			description: '',
			id: uuid(),
			team_instructions: ''
		})

		setAddOn({
			...addOn,
			addon_choices: choices
		})
	}

	const updateDayOfWeek = (day, value) => {
		if (isNaN(value)) return
		const days = addOn.days_of_week || default_days
		const newVal = value === '' ? '' : Number(value)
		days[day] = newVal

		setAddOn({
			...addOn,
			days_of_week: days
		})
	}

	return (
		<Dialog
			open={isShown}
			onClose={() => {
				setIsShown()
				setAddOn({
					name: '',
					price: 0,
					min_price: 0,
					max_price: 0,
					temp_file: null,
					available_boarding: true,
					available_daycare: true,
					daycare_default_time: 'midday',
					boarding_default_time: 'midday'
				})
				setIconApplied(false)
			}}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<Card style={{ marginTop: '0px', marginBottom: 0 }}>
				<CardHeader
					avatar={
						<div>
							<IconButton onClick={() => setIsShown(false)}>
								<ArrowBackIcon style={{ fill: '#777679' }} />
							</IconButton>
						</div>
					}
					style={{
						borderBottom: '1px solid #D0CFD2'
					}}
					title={
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'flex-start',
								alignItems: 'flex-start'
							}}>
							<Typography
								variant="body2"
								style={{
									fontWeight: '800',
									color: '#270050',
									fontSize: 16
								}}>
								{addOn._id ? 'Edit Enrichment' : 'New Enrichment'}
							</Typography>
						</div>
					}
				/>
				<CardContent style={{ overflowY: 'scroll', height: 600, paddingBottom: 96 }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							paddingTop: 12,
							paddingBottom: 12
						}}>
						<Typography
							variant="body2"
							style={{
								color: '#1A1A35',
								fontWeight: '800',
								fontSize: 16
							}}>
							Details
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Name"
							variant="filled"
							style={{
								width: '49%'
							}}
							error={addOn?.name?.length > 20}
							value={addOn.name}
							onChange={(e) => {
								setAddOn({
									...addOn,
									name: e.target.value
								})
							}}
							helperText={`${addOn.name.length} / 20 Max Characters`}
						/>
						<TextField
							label="Category"
							variant="filled"
							select
							style={{
								width: '49%'
							}}
							disabled={false}
							onChange={(e) => {
								const updatedAddon = { ...addOn, type: e.target.value }
								const category = addOnCategories.find((c) => c._id === e.target.value)

								updatedAddon.standalone_service = category && category.standalone_service

								if (category && category.training_service) {
									updatedAddon.training_service = true
								} else {
									updatedAddon.training_service = false
								}
								setAddOn(updatedAddon)
							}}
							value={addOn.type}>
							{addOnCategories.map((cat, i) => {
								return (
									<MenuItem key={`category-${i}`} value={cat._id}>
										{cat.name}
									</MenuItem>
								)
							})}
						</TextField>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							marginTop: 12
						}}>
						<TextField
							label="Frequency"
							variant="filled"
							style={{
								width: '49%'
							}}
							select
							disabled={false}
							onChange={(e) => {
								setAddOn({
									...addOn,
									category: e.target.value
								})
							}}
							value={addOn.category}>
							<MenuItem value="pet">Single occurrence</MenuItem>
							<MenuItem value="schedule">Multiple occurrences</MenuItem>
						</TextField>

						<TextField
							label="Access"
							variant="filled"
							style={{
								width: '49%'
							}}
							select
							onChange={(e) => {
								let val = e.target.value
								if (val === 'Inactive') {
									setAddOn({
										...addOn,
										access: 'Inactive',
										active: false
									})
								} else {
									setAddOn({
										...addOn,
										access: val,
										active: true
									})
								}
							}}
							value={getAccess(addOn)}>
							<MenuItem value="Inactive">Inactive</MenuItem>
							{!isAStandaloneService ? (
								<MenuItem value={ACCESS_TYPES.GlobalAccess}>{ACCESS_TYPES.GlobalAccess}</MenuItem>
							) : null}
							<MenuItem value={ACCESS_TYPES.AdminOnly}>{ACCESS_TYPES.AdminOnly}</MenuItem>
						</TextField>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							marginTop: 24
						}}>
						<TextField
							label="Client Description"
							variant="filled"
							style={{
								width: '100%'
							}}
							error={addOn?.description?.length > 350}
							onChange={(e) => {
								setAddOn({
									...addOn,
									description: e.target.value
								})
							}}
							value={addOn.description}
							helperText={`${addOn.description ? addOn.description.length : 0} / 350 Max Characters`}
						/>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							marginTop: 12
						}}>
						<TextField
							label="Team Member Instructions"
							variant="filled"
							style={{
								width: '100%'
							}}
							multiline={true}
							error={addOn?.team_instructions?.length > 300}
							onChange={(e) => {
								setAddOn({
									...addOn,
									team_instructions: e.target.value
								})
							}}
							value={addOn.team_instructions}
							helperText={`${
								addOn.team_instructions ? addOn.team_instructions.length : 0
							} / 300 Max Characters`}
						/>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							marginTop: 16,
							marginBottom: 24
						}}>
						{!iconApplied ? (
							<div style={{ width: '50%' }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'flex-start',
										alignItems: 'center',
										marginTop: 12
									}}>
									<TextField
										label="Icon Name"
										variant="filled"
										style={{
											width: '70%'
										}}
										value={addOn.icon}
										onChange={(e) => {
											setAddOn({
												...addOn,
												icon: e.target.value ? e.target.value.toLowerCase() : ''
											})
										}}
									/>
									<Button
										variant="outlined"
										style={{
											marginLeft: 26,
											height: 40
										}}
										onClick={() => {
											setIconApplied(true)
										}}
										disabled={false}
										color="secondary">
										Apply
									</Button>
								</div>
								<div
									style={{
										paddingTop: 4,
										paddingBottom: 4
									}}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#4D4C4F',
											fontSize: 14,
											opacity: 0.8
										}}>
										Enter the icon name found on{' '}
										<a
											target="_blank"
											style={{ textDecoration: 'none' }}
											href="https://fontawesome.com/icons?d=gallery">
											Font Awesome’s Website.
										</a>
									</Typography>
								</div>
							</div>
						) : (
							<div style={{ width: '50%' }}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'space-between',
										alignItems: 'center'
									}}>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'flex-start',
											alignItems: 'center',
											backgroundColor: '#F3F3F3',
											borderRadius: 6,
											height: 56,
											width: '99%',
											paddingLeft: 16
										}}>
										<Icon
											className={`fa fa-${getIconName(addOn)}`}
											style={{
												fontWeight: '900',
												fontSize: '16px',
												color: '#270050',
												width: 20
												// overflow: "visible",
											}}
										/>
										<Typography
											variant="body2"
											style={{
												fontWeight: '800',
												color: '#270050',
												fontSize: 16,
												marginLeft: 12,
												textTransform: 'uppercase'
											}}>
											{getIconName(addOn)}
										</Typography>
									</div>
									<div
										style={{
											width: '44%',
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'flex-start',
											alignItems: 'center'
										}}>
										<Button
											variant="outlined"
											style={{
												marginLeft: 12,
												height: 40
											}}
											onClick={() => {
												setIconApplied(false)
												setAddOn({
													...addOn,
													icon: ''
												})
											}}
											color="secondary">
											Remove
										</Button>
									</div>
								</div>
							</div>
						)}
						<div
							style={{
								width: '50%',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'flex-end',
								alignItems: 'center',
								marginTop: '-10px'
							}}>
							<div
								style={{
									display: 'flex',
									width: '100%',
									flexDirection: 'column',
									justifyContent: 'flex-start',
									alignItems: 'flex-end'
								}}>
								<TextField
									label="Upload Photo"
									variant="filled"
									style={{
										width: '95%',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										overflow: 'hidden'
									}}
									noWrap
									onChange={() => {}}
									value={addOn.image_url || addOn?.temp_file?.name || ''}
									InputProps={{
										style: {
											width: '100%',
											textOverflow: 'ellipsis',
											whiteSpace: 'nowrap',
											overflow: 'hidden'
										},
										endAdornment: (
											<InputAdornment position="end">
												{imageLoading ? (
													<CircularProgress size={40} color="primary" />
												) : (
													<label htmlFor={`addon-image`} style={{}}>
														<Button
															component="span"
															style={{
																fontSize: 14,
																fontWeight: '700',
																color: '#6B4AD6',
																textTransform: 'capitalize'
															}}>
															Upload
														</Button>
													</label>
												)}
											</InputAdornment>
										)
									}}
								/>
								<div className={classes.fileUpload}>
									<input
										hidden
										accept="image/*, application/pdf"
										className={classes.input}
										id={`addon-image`}
										type="file"
										ref={waiverInputRef}
										onChange={(e) => uploadFile(e)}
									/>
								</div>
							</div>
						</div>
					</div>
					<div
						style={{
							flex: 1,
							display: 'flex',
							flexDirection: 'row',
							gap: '1rem'
						}}>
						<div
							style={{
								flex: 1,
								display: 'flex',
								flexDirection: 'row'
							}}>
							<StyledSelect
								label="Revenue Type"
								header=""
								value={addOn.revenue_type}
								onChange={(e) => {
									const val = e.target.value
									setAddOn({
										...addOn,
										revenue_type: val
									})
								}}>
								{Object.entries(ADDON_REVENUE_TYPES).map(([key, value]) => {
									return (
										<MenuItem key={key} value={key}>
											{value}
										</MenuItem>
									)
								})}
							</StyledSelect>
						</div>
						<div style={{ flex: 1 }}>{NON_BREAKING_SPACE}</div>
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							paddingTop: 24,
							paddingBottom: 12
						}}>
						<Typography
							variant="body2"
							style={{
								color: '#1A1A35',
								fontWeight: '800',
								fontSize: 16
							}}>
							Availability
						</Typography>
					</div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Availability Type"
							variant="filled"
							style={{
								width: '31%',
								minWidth: 200
							}}
							select
							onChange={(e) => {
								let val = e.target.value
								setAddOn({
									...addOn,
									limited: val ? true : false
								})
							}}
							value={addOn.limited ? true : false}>
							<MenuItem value={false}>Unlimited</MenuItem>
							<MenuItem value={true}>Limited</MenuItem>
						</TextField>
						{addOn.limited ? (
							<React.Fragment>
								<KeyboardDatePicker
									disableToolbar
									style={{
										minWidth: '200px',
										width: '31%',
										margin: 0,
										marginBottom: 16
									}}
									InputAdornmentProps={{
										position: 'start',
										component: () => (
											<IconButton onClick={() => setIsStartDateOpen(true)}>
												<Icon
													className="far fa-calendar-alt"
													style={{
														fontSize: '1.325rem'
													}}
												/>
											</IconButton>
										)
									}}
									open={isStartDateOpen}
									onOpen={() => setIsStartDateOpen(true)}
									onClose={() => setIsStartDateOpen(false)}
									variant="inline"
									format="MM/DD/YYYY"
									margin="normal"
									id="start-date"
									label="Start Date"
									inputVariant="filled"
									value={addOn.startDate || null}
									onChange={(d) => {
										setAddOn({
											...addOn,
											startDate: d.format('YYYY-MM-DD')
										})
										if (d && addOn.endDate) {
											let dates = getDates(d, addOn.endDate)
											setAddOn({
												...addOn,
												startDate: d.format('YYYY-MM-DD'),
												dates
											})
										}
									}}
									className={classes.datePicker}
									rightArrowIcon={
										<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
									}
									leftArrowIcon={
										<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
									}
									KeyboardButtonProps={{
										'aria-label': 'Start Date',
										className: classes.calendarButton
									}}
								/>
								<KeyboardDatePicker
									disableToolbar
									style={{
										minWidth: '200px',
										width: '31%',
										margin: 0
									}}
									InputAdornmentProps={{
										position: 'start',
										component: () => (
											<IconButton onClick={() => setIsEndDateOpen(true)}>
												<Icon
													className="far fa-calendar-alt"
													style={{
														fontSize: '1.325rem'
													}}
												/>
											</IconButton>
										)
									}}
									open={isEndDateOpen}
									onOpen={() => setIsEndDateOpen(true)}
									onClose={() => setIsEndDateOpen(false)}
									variant="inline"
									format="MM/DD/YYYY"
									margin="normal"
									id="end-date"
									label="End Date"
									inputVariant="filled"
									value={addOn.endDate || null}
									onChange={(d) => {
										setAddOn({
											...addOn,
											endDate: d.format('YYYY-MM-DD')
										})
										if (d && addOn.startDate) {
											let dates = getDates(addOn.startDate, d)
											setAddOn({
												...addOn,
												endDate: d.format('YYYY-MM-DD'),
												dates
											})
										}
									}}
									className={classes.datePicker}
									rightArrowIcon={
										<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
									}
									leftArrowIcon={
										<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
									}
									KeyboardButtonProps={{
										'aria-label': 'End Date',
										className: classes.calendarButton
									}}
								/>
							</React.Fragment>
						) : null}
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							marginTop: 12
						}}>
						<TextField
							label="Availability Message"
							variant="filled"
							style={{
								width: '100%'
							}}
							onChange={(e) => {
								let val = e.target.value
								setAddOn({
									...addOn,
									availability_message: val
								})
							}}
							value={addOn.availability_message}
							error={addOn.availability_message?.length > 20}
							helperText={`${
								addOn.availability_message ? addOn.availability_message.length : 0
							} / 20 Max Characters`}
						/>
					</div>

					<Typography
						variant="body2"
						style={{
							color: '#1A1A35',
							fontWeight: '400',
							fontSize: 16,
							marginTop: 36
						}}>
						Enter the service capacity limits for each day of the week for the enrichment.
					</Typography>

					<div className={classes.daysOfWeek}>
						{days_of_week.map((day) => {
							let val = ''
							if (addOn.days_of_week && (addOn.days_of_week[day] || addOn.days_of_week[day] === 0))
								val = addOn.days_of_week[day]
							return (
								<TextField
									key={`day-${day}`}
									label={`${day} Capacity Limit`}
									variant="filled"
									style={{
										width: '32%',
										minWidth: 200,
										marginTop: 16
									}}
									onChange={(e) => {
										updateDayOfWeek(day, e.target.value)
									}}
									value={val}
								/>
							)
						})}
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							marginTop: 12
						}}>
						<Typography
							variant="body2"
							style={{
								color: '#1A1A35',
								fontWeight: '400',
								fontSize: 16,
								marginTop: 16,
								marginBottom: 16
							}}>
							Specific Blocked Dates (updates automatically from daily capacity as well)
						</Typography>
						<DatePicker
							multiple={true}
							value={addOn?.blocked_dates ? addOn.blocked_dates.map((d) => moment(d).toDate()) : []}
							onChange={(val) => {
								let mapped = val.map((v) => {
									if (v.format) return v.format()
									return v
								})

								// console.log('mappeed', mapped)

								setAddOn({
									...addOn,
									blocked_dates: mapped
								})
							}}
							placeholder="Blocked Dates"
							currentDate={null}
							format="MM/DD/YY"
							containerStyle={{
								zIndex: 999
							}}
							style={{
								width: '100%',
								height: 56,
								margin: 0,
								borderBottomLeftRadius: 0,
								borderBottomRightRadius: 0,
								backgroundColor: '#FFFFFF',
								border: '1px solid #D0CFD2',
								paddingTop: 18,
								paddingLeft: 16,
								fontSize: 16,
								fontFamily: 'Nunito',
								color: '#777679',
								zIndex: 999,
								backgroundColor: '#FFFFFF'
							}}
						/>
					</div>

					<div
						style={{
							marginTop: 24
							// display: addOn.limited ? 'none' : ''
						}}>
						<div className={classes.switchBox}>
							<Typography
								variant="body2"
								style={{
									fontWeight: '600',
									color: '#1A1A35',
									fontSize: 16
								}}>
								Do Not Show If Unavailable
							</Typography>
							<Switch
								checked={addOn.do_not_show_if_unavailable}
								onChange={() => {
									setAddOn({
										...addOn,
										do_not_show_if_unavailable: !addOn.do_not_show_if_unavailable
									})
								}}
								name="do_not_show_if_unavailable"
								icon={
									<div className={classes.thumb}>
										<Icon className="far fa-times" />
									</div>
								}
								checkedIcon={
									<div className={classes.thumb}>
										<Icon className="far fa-check" />
									</div>
								}
								classes={{
									root: classes.switchRoot,
									switchBase: classes.switchBase,
									thumb: classes.thumb,
									track: classes.track,
									checked: classes.checked
								}}
							/>
						</div>
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							paddingTop: 24,
							paddingBottom: 6
						}}>
						<Typography
							variant="body2"
							style={{
								color: '#1A1A35',
								fontWeight: '800',
								fontSize: 16
							}}>
							Pricing
						</Typography>
					</div>

					<div className={classes.switchBox}>
						<Typography
							variant="body2"
							style={{
								fontWeight: '600',
								color: '#1A1A35',
								fontSize: 16
							}}>
							Set Price to “Varies”
						</Typography>
						<Switch
							checked={addOn.set_price_to_varies}
							disabled={false}
							onChange={() => {
								setAddOn({
									...addOn,
									set_price_to_varies: !addOn.set_price_to_varies
								})
							}}
							name="sharingKennels"
							icon={
								<div className={classes.thumb}>
									<Icon className="far fa-times" />
								</div>
							}
							checkedIcon={
								<div className={classes.thumb}>
									<Icon className="far fa-check" />
								</div>
							}
							classes={{
								root: classes.switchRoot,
								switchBase: classes.switchBase,
								thumb: classes.thumb,
								track: classes.track,
								checked: classes.checked
							}}
						/>
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: addOn.variable_price ? 'space-between' : 'flex-start',
							marginTop: 24
						}}>
						<TextField
							label="Pricing"
							variant="filled"
							style={{
								width: '32%',
								minWidth: 200
							}}
							onChange={(e) => {
								setAddOn({
									...addOn,
									variable_price: e.target.value
								})
							}}
							value={addOn.variable_price ? true : false}
							select>
							<MenuItem value={false}>Fixed Price</MenuItem>
							<MenuItem value={true}>Variable Price</MenuItem>
						</TextField>

						{addOn.variable_price ? (
							<React.Fragment>
								<TextField
									label="Min Price"
									variant="filled"
									style={{
										width: '32%',
										minWidth: 200
									}}
									onChange={(e) => setAddOn({ ...addOn, min_price: e.target.value })}
									value={formatNumsToDollars(onlyNumbers(addOn.min_price))}
									InputProps={{
										style: {
											textTransform: 'capitalize',
											minWidth: 200
										},
										startAdornment: (
											<InputAdornment className={classes.currencyAdornment} position="start">
												$
											</InputAdornment>
										)
									}}
								/>
								<TextField
									label="Max Price"
									variant="filled"
									style={{
										width: '32%',
										minWidth: 200
									}}
									onChange={(e) => setAddOn({ ...addOn, max_price: e.target.value })}
									value={formatNumsToDollars(onlyNumbers(addOn.max_price))}
									InputProps={{
										style: {
											textTransform: 'capitalize',
											minWidth: 200
										},
										startAdornment: (
											<InputAdornment className={classes.currencyAdornment} position="start">
												$
											</InputAdornment>
										)
									}}
								/>
							</React.Fragment>
						) : (
							<TextField
								label="Price"
								variant="filled"
								onChange={(e) => setAddOn({ ...addOn, price: e.target.value })}
								value={formatNumsToDollars(onlyNumbers(addOn.price))}
								style={{
									width: '32%',
									minWidth: 200,
									marginLeft: 24
								}}
								InputProps={{
									style: {
										textTransform: 'capitalize',
										minWidth: 200
									},
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
							/>
						)}
					</div>
					{/* <div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'center',
							marginTop: 12
						}}>
						<Checkbox
							checked={addOn.taxable ? true : false}
							onChange={() => setAddOn({ ...addOn, taxable: !addOn.taxable })}
						/>
						<Typography
							variant="body2"
							style={{
								fontWeight: '600',
								color: '#1A1A35',
								fontSize: 16,
								marginLeft: 12
							}}>
							This is a taxable item
						</Typography>
					</div> */}

					<div style={{ marginTop: 24 }}>
						<div className={classes.switchBox}>
							<Typography
								variant="body2"
								style={{
									fontWeight: '600',
									color: '#1A1A35',
									fontSize: 16
								}}>
								Enrichment Choices
							</Typography>
							<Switch
								checked={addOn.has_choices}
								disabled={false}
								onChange={() => {
									if (!addOn.has_choices) {
										if (addOn?.addon_choices?.length) {
											setAddOn({
												...addOn,
												has_choices: true
											})
										} else {
											setAddOn({
												...addOn,
												has_choices: true,
												addon_choices: [
													{
														name: 'Standard',
														upcharge: 0,
														is_standard: true,
														description: '',
														id: uuid(),
														team_instructions: ''
													}
												]
											})
										}
									} else {
										setAddOn({
											...addOn,
											has_choices: false
										})
									}
								}}
								name="sharingKennels"
								icon={
									<div className={classes.thumb}>
										<Icon className="far fa-times" />
									</div>
								}
								checkedIcon={
									<div className={classes.thumb}>
										<Icon className="far fa-check" />
									</div>
								}
								classes={{
									root: classes.switchRoot,
									switchBase: classes.switchBase,
									thumb: classes.thumb,
									track: classes.track,
									checked: classes.checked
								}}
							/>
						</div>
					</div>
					{addOn.has_choices && addOn?.addon_choices
						? addOn.addon_choices.map((choice) => (
								<AddOnChoice
									choice={choice}
									updateChoice={updateChoice}
									removeChoice={removeChoice}
								/>
						  ))
						: null}
					{addOn.has_choices && (
						<Button
							variant="outlined"
							color="secondary"
							style={{ paddingLeft: 24, paddingRight: 24, marginBottom: 24 }}
							startIcon={<i className="fa fa-plus" />}
							onClick={(e) => addChoice()}>
							Enrichment Choice
						</Button>
					)}

					{!isAStandaloneService ? (
						<>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									paddingTop: 36,
									paddingBottom: 6
								}}>
								<Typography
									variant="body2"
									style={{
										color: '#1A1A35',
										fontWeight: '800',
										fontSize: 16
									}}>
									Daycare Scheduling
								</Typography>
							</div>
							<div>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										Available for Daycare
									</Typography>
									<Switch
										checked={addOn.available_daycare}
										onChange={() => {
											setAddOn({
												...addOn,
												available_daycare: !addOn.available_daycare
											})
										}}
										name="sharingKennels"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									marginTop: 24
								}}>
								<Typography
									variant="body2"
									style={{
										color: '#1A1A35',
										fontSize: 16,
										marginRight: 12
									}}>
									Choose when this enrichment will occur by default per service line.
								</Typography>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									marginTop: 12
								}}>
								<TextField
									label="Default Time (Daycare)"
									variant="filled"
									style={{
										width: '49%'
									}}
									select
									onChange={(e) => {
										setAddOn({
											...addOn,
											daycare_default_time: e.target.value
										})
									}}
									value={addOn.daycare_default_time}>
									<MenuItem value="morning">Morning</MenuItem>
									<MenuItem value="midday">Midday</MenuItem>
									<MenuItem value="evening">Evening</MenuItem>
								</TextField>
							</div>
						</>
					) : null}
					{addOn.category === 'schedule' ? (
						<div
							style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
								justifyContent: 'flex-start'
							}}>
							<Typography
								variant="body2"
								style={{
									color: '#1A1A35',
									fontWeight: '400',
									fontSize: 16,
									marginTop: 16
								}}>
								Choose all the options by service line that will be available to schedule
							</Typography>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'flex-start',
									marginTop: 12,
									border: '1px solid #D5D5D7',
									borderRadius: 6,
									width: '100%'
								}}>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={daycareTimes.includes('morning')}
										onClick={() => setTime('daycare', 'morning')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Morning
									</Typography>
								</div>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={daycareTimes.includes('midday')}
										onClick={() => setTime('daycare', 'midday')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Midday
									</Typography>
								</div>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={daycareTimes.includes('evening')}
										onClick={() => setTime('daycare', 'evening')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Evening
									</Typography>
								</div>
								<div className={classes.checkRow}></div>
							</div>
						</div>
					) : null}
					{!isAStandaloneService ? (
						<>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									paddingTop: 36,
									paddingBottom: 6
								}}>
								<Typography
									variant="body2"
									style={{
										color: '#1A1A35',
										fontWeight: '800',
										fontSize: 16
									}}>
									Boarding Scheduling
								</Typography>
							</div>
							<div>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										Available for Boarding
									</Typography>
									<Switch
										checked={addOn.available_boarding}
										onChange={() => {
											setAddOn({
												...addOn,
												available_boarding: !addOn.available_boarding
											})
										}}
										name="sharingKennels"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									marginTop: 24
								}}>
								<Typography
									variant="body2"
									style={{
										color: '#1A1A35',
										fontSize: 16,
										marginRight: 12
									}}>
									Choose when this enrichment will occur by default per service line.
								</Typography>
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									marginTop: 12
								}}>
								<TextField
									label="Default Time (Boarding)"
									variant="filled"
									style={{
										width: '49%'
									}}
									select
									onChange={(e) => {
										setAddOn({
											...addOn,
											boarding_default_time: e.target.value
										})
									}}
									value={addOn.boarding_default_time}>
									<MenuItem value="morning">Morning</MenuItem>
									<MenuItem value="midday">Midday</MenuItem>
									<MenuItem value="evening">Evening</MenuItem>
									<MenuItem value="night">Night</MenuItem>
								</TextField>
							</div>
						</>
					) : null}

					{addOn.category === 'schedule' ? (
						<div
							style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
								justifyContent: 'flex-start'
							}}>
							<Typography
								variant="body2"
								style={{
									color: '#1A1A35',
									fontWeight: '400',
									fontSize: 16,
									marginTop: 16
								}}>
								Choose all the options by service line that will be available to schedule
							</Typography>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'flex-start',
									marginTop: 12,
									border: '1px solid #D5D5D7',
									borderRadius: 6,
									width: '100%'
								}}>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={boardingTimes.includes('morning')}
										onClick={() => setTime('boarding', 'morning')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Morning
									</Typography>
								</div>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={boardingTimes.includes('midday')}
										onClick={() => setTime('boarding', 'midday')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Midday
									</Typography>
								</div>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={boardingTimes.includes('evening')}
										onClick={() => setTime('boarding', 'evening')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Evening
									</Typography>
								</div>
								<div className={classes.checkRow} style={{ borderRight: '1px solid #D5D5D7' }}>
									<Checkbox
										checked={boardingTimes.includes('night')}
										onClick={() => setTime('boarding', 'night')}
									/>

									<Typography
										variant="body2"
										style={{
											color: '#1A1A35',
											fontSize: 16,
											marginLeft: 12
										}}>
										Night
									</Typography>
								</div>
							</div>
						</div>
					) : null}
					{!isAStandaloneService ? (
						<>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									paddingTop: 36,
									paddingBottom: 6
								}}>
								<Typography
									variant="body2"
									style={{
										color: '#1A1A35',
										fontWeight: '800',
										fontSize: 16
									}}>
									Training Scheduling
								</Typography>
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										Training Service
									</Typography>
									<Switch
										checked={addOn.training_service}
										onChange={(e) => {
											const checked = e.target.checked
											if (checked && addOn.available_during_training_session) {
												setAddOn({
													...addOn,
													training_service: checked,
													available_during_training_session: false
												})
											} else {
												setAddOn({
													...addOn,
													training_service: checked
												})
											}
										}}
										name="trainingService"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									Check this when an enrichment is meant to be associated with a Training Course.
								</div>
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', marginTop: '1rem' }}>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										VIP Membership Enrichment
									</Typography>
									<Switch
										checked={!!addOn.vip_only}
										onChange={(e) => {
											setAddOn({
												...addOn,
												vip_only: e.target.checked
											})
										}}
										name="vipOnly"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									Mark when an enrichment is included with VIP membership (1 per dog per month).
								</div>
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', marginTop: '1rem' }}>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										Signature Stay Enrichment
									</Typography>
									<Switch
										checked={!!addOn.comfort_plus_included}
										onChange={(e) => {
											setAddOn({
												...addOn,
												comfort_plus_included: e.target.checked
											})
										}}
										name="comfortPlusIncluded"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									Include this enrichment automatically when Signature Stay (Comfort Plus) boarding
									is selected.
								</div>
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', marginTop: '1rem' }}>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										Signature Play Enrichment
									</Typography>
									<Switch
										checked={!!addOn.signature_play_included}
										onChange={(e) => {
											setAddOn({
												...addOn,
												signature_play_included: e.target.checked
											})
										}}
										name="signaturePlayIncluded"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									Include this enrichment automatically when Signature Play daycare is selected.
								</div>
							</div>
							<div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
								<div className={classes.switchBox}>
									<Typography
										variant="body2"
										style={{
											fontWeight: '600',
											color: '#1A1A35',
											fontSize: 16
										}}>
										Available during Play & Study
									</Typography>
									<Switch
										checked={addOn.available_during_training_session}
										disabled={addOn.training_service}
										onChange={() => {
											setAddOn({
												...addOn,
												available_during_training_session:
													!addOn.available_during_training_session
											})
										}}
										name="availablePlayStudy"
										icon={
											<div className={classes.thumb}>
												<Icon className="far fa-times" />
											</div>
										}
										checkedIcon={
											<div className={classes.thumb}>
												<Icon className="far fa-check" />
											</div>
										}
										classes={{
											root: classes.switchRoot,
											switchBase: classes.switchBase,
											thumb: classes.thumb,
											track: classes.track,
											checked: classes.checked
										}}
									/>
								</div>
								<div style={{ display: 'flex', alignItems: 'center' }}>
									Check this if an enrichment is available during a training related facility
									visit.
								</div>
							</div>
						</>
					) : null}
				</CardContent>
			</Card>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					alignItems: 'center',
					padding: 24,
					paddingTop: 16,
					paddingBottom: 16,
					borderTop: '1px solid #D0CFD2',
					backgroundColor: '#FFFFFF'
				}}>
				<Button
					variant="contained"
					onClick={() => {
						saveAddOn(addOn)
					}}
					disabled={isNotReady()}
					color="secondary"
					style={{
						marginRight: 16
					}}>
					{loading ? <CircularProgress /> : addOn._id ? 'Save Enrichment' : 'Create Enrichment'}
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)

						setAddOn({
							name: '',
							price: 0,
							min_price: 0,
							max_price: 0,
							temp_file: null,
							available_boarding: true,
							available_daycare: true,
							daycare_default_time: 'midday',
							boarding_default_time: 'midday'
						})
						setIconApplied(false)
					}}
					color="secondary">
					Cancel
				</Button>{' '}
			</div>
		</Dialog>
	)
}

const AddOnChoice = ({ choice, updateChoice, removeChoice }) => {
	const classes = useStyles()

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	let disabled = false

	return (
		<div style={{ marginBottom: 36 }} key={choice?.id || 'choice'}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					marginTop: 16
				}}>
				<TextField
					label="Choice Name"
					variant="filled"
					disabled={disabled}
					style={{
						width: '32%',
						minWidth: 200,
						marginRight: 24
					}}
					onChange={(e) => {
						updateChoice(choice.id, 'name', e.target.value)
					}}
					value={choice.name}
				/>
				<TextField
					label="Upcharge"
					variant="filled"
					style={{
						width: '32%',
						minWidth: 200,
						marginRight: 24
					}}
					value={formatNumsToDollars(onlyNumbers(choice.upcharge))}
					InputProps={{
						style: {
							textTransform: 'capitalize',
							minWidth: 200
						},
						startAdornment: (
							<InputAdornment className={classes.currencyAdornment} position="start">
								$
							</InputAdornment>
						)
					}}
					disabled={choice.is_standard || disabled ? true : false}
					onChange={(e) => {
						updateChoice(choice.id, 'upcharge', e.target.value)
					}}
				/>
				{choice.is_standard ? null : (
					<Button
						className={classes.errorBtn}
						onClick={() => removeChoice(choice.id)}
						disabled={disabled}>
						<Close style={{ fill: disabled ? 'gray' : '#DC2A2A' }} />
					</Button>
				)}
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					marginTop: 16
				}}>
				<TextField
					label="Client Choice Description"
					variant="filled"
					disabled={disabled}
					style={{
						width: '100%',
						minWidth: 200
					}}
					helperText={`${choice.description?.length || 0} / 35 Max Characters`}
					error={choice?.description?.length > 35}
					onChange={(e) => {
						updateChoice(choice.id, 'description', e.target.value)
					}}
					value={choice.description}
				/>
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-start',
					marginTop: 16
				}}>
				<TextField
					label="Client Team Member Instructions"
					variant="filled"
					disabled={disabled}
					style={{
						width: '100%',
						minWidth: 200
					}}
					helperText={`${choice.team_instructions?.length || 0} / 35 Max Characters`}
					error={choice?.team_instructions?.length > 35}
					onChange={(e) => {
						updateChoice(choice.id, 'team_instructions', e.target.value)
					}}
					value={choice.team_instructions}
				/>
			</div>
		</div>
	)
}

export default NewAddOnDialog
